import { UserRole } from "tm-shared/types";

export interface MemberInfoCapabilities {
    canSeeMemberHeader: boolean;
    canSeeSalary: boolean;
    canSeeDashboardTabs: boolean;
}

export const getMemberInfoCapabilities = (
    role: UserRole | null,
): MemberInfoCapabilities => ({
    canSeeMemberHeader: role === UserRole.Sv,
    canSeeSalary: role === UserRole.Sv,
    canSeeDashboardTabs: role === UserRole.Sv,
});
